// extracted by mini-css-extract-plugin
export var box = "_27-1";
export var checkboxRow = "_27-8";
export var checked = "_27-2";
export var descriptionSpacer = "_27-a";
export var disabled = "_27-3";
export var icon = "_27-6";
export var input = "_27-0";
export var labelSpacer = "_27-9";
export var medium = "_27-5";
export var small = "_27-4";
export var text = "_27-7";